const PopupSearch = (button) => {
    if (typeof button != "undefined" && button != null ) {
        button.addEventListener('click', () => {
            const mobileMenu = document.querySelector('.mobile-menu--active');
            const headerButton = document.querySelector('.header__mobile');

            if (typeof mobileMenu != "undefined" && mobileMenu != null && headerButton != "undefined" && headerButton != null) {
                mobileMenu.classList.remove('mobile-menu--active');
                headerButton.classList.remove('active');
            }

        });
    }

    const popupSearchBg = document.querySelector('.popup-search__bg');

    if (typeof popupSearchBg != "undefined" && popupSearchBg != null) {
        popupSearchBg.addEventListener('click', () => {
            const popupSearch = document.querySelector('.popup-search');
            popupSearch.classList.remove('popup-search--active');
        });
    }
}

export default PopupSearch;
